module.exports = __webpack_public_path__ + "img/expired.e50e441a.svg";